<div class="pt-big px-plus">
  <div class="d-flex flex-column align-items-center">
    <lib-ngx-skeleton-loading
      [height]="'46px'"
      [width]="'158px'"
    ></lib-ngx-skeleton-loading>
    <div class="pt-pony">
      <lib-ngx-skeleton-loading
        [height]="'40px'"
        [width]="'168px'"
      ></lib-ngx-skeleton-loading>
    </div>
  </div>
  <div class="pt-huge d-flex justify-content-space-between">
    <lib-ngx-skeleton-loading
      [height]="'36px'"
      [width]="'70px'"
    ></lib-ngx-skeleton-loading>
    <lib-ngx-skeleton-loading
      [height]="'36px'"
      [width]="'55px'"
    ></lib-ngx-skeleton-loading>
  </div>
  <div class="pt-minus gap-minus">
    <lib-ngx-skeleton-loading
      [height]="'216px'"
      [width]="'100%'"
    ></lib-ngx-skeleton-loading>
  </div>
  <div class="pt-huge d-flex justify-content-space-between">
    <lib-ngx-skeleton-loading
      [height]="'36px'"
      [width]="'70px'"
    ></lib-ngx-skeleton-loading>
    <lib-ngx-skeleton-loading
      [height]="'36px'"
      [width]="'55px'"
    ></lib-ngx-skeleton-loading>
  </div>
  <div class="pt-minus gap-minus">
    <lib-ngx-skeleton-loading
      [height]="'216px'"
      [width]="'100%'"
    ></lib-ngx-skeleton-loading>
  </div>
</div>
